<!-- FormWizard.vue -->
<template>
  <div>
    <app-breadcrumb
        :page-title="$t('Save Form Wizard')"
        :directory="$t('Save Form Wizard')"
        :icon="'sidebar'"
    />
    <form-selection @next="nextStep" v-if="step === 1" :formRevisionId="formRevisionId"/>
    <create-or-update-form @next="nextStep" v-if="step === 2" />
    <!-- Add another step/component if needed -->
    <form-preview v-if="step === 3" :id="getId" :userId="userId" newVersion=''
                  taskId="0" :form_id="getFormId" :back="formSaved"
                  :form_revision_id="getFormRevisionId"
                  response="save_response">
    </form-preview>

    <div class="mt-2">
      <button class="btn btn-primary" type="submit" @click="previousStep" v-if="step > 1">Previous</button>
      <button class="btn btn-primary" type="submit" @click="nextStep" v-if="step < maxStep && canProceed">Next</button>
    </div>
  </div>
</template>

<script>
import FormSelection from './FormSelection.vue';
import CreateOrUpdateForm from './CreateOrUpdateForm.vue';

export default {
  components: {
    FormSelection,
    CreateOrUpdateForm,
  },
  data() {
    return {
      step: 1, // Current step of the wizard
      maxStep: 3, // Total number of steps
      canProceed: false, // Controls whether the user can proceed to the next step
      backDoor: 0,

    };
  },
  computed: {
    formRevisionId(){
      return Number(this.$attrs.formrevisionid);
    },
    getId(){
      this.backDoor;
      return this.$store.state.saveFormState.formBodyId
    },
    getFormId(){
      this.backDoor;
      return this.$store.state.saveFormState.formId
    },
    getFormRevisionId(){
      this.backDoor;
      return this.$store.state.saveFormState.formRevisionId
    },
    userId() {
      this.backDoor;
      return this.$store.state.user.loggedInUser.id;
    }
  },
  mounted(){

    this.$hub.$on('canProceed', (status) => {
      this.canProceed = status;
      this.step++
    })
  },
  watch: {

  },
  methods: {
    nextStep() {
      this.backDoor++;
      if (this.step === 1) {
        // Check if a form is selected before proceeding to the next step
        if (this.$store.state.saveFormState.selectedFormRevisionId) {
          this.canProceed = true;

        } else {
          // this.$hub.$emit("formSelected", false);
          // console.error('Something went wrong!')
          // Handle error or display a message to select a form
          return;
        }
      } else if (this.step === 2) {
        // this.$emit('formSelected', true)
        this.canProceed = false;
        this.$hub.$emit("formSelected", true);
        setTimeout(() => {
          this.canProceed = true;
        }, 1000)

        // Handle logic for the second step, e.g., validation or submission
      }

      if (this.step < this.maxStep && this.canProceed) {
        this.step++;
      }
    },
    previousStep() {
      this.backDoor++;
      if (this.step > 1) {
        this.step--;
        this.canProceed = true; // Allow user to proceed back
      }
    },
    formSaved() {
      setTimeout(() => {
        this.$toastr.i('You can share the response now.');

      }, 2000)

    }

  },
};
</script>
